var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.19281C6.71562 0.19281 0 6.66981 0 14.6598C0 22.6498 6.71562 29.1268 15 29.1268C23.2844 29.1268 30 22.6498 30 14.6598C30 6.66981 23.2844 0.19281 15 0.19281ZM11.3281 20.6561H8.29062V11.2284H11.3281V20.6561ZM9.79062 10.0711C8.83125 10.0711 8.21094 9.41553 8.21094 8.60477C8.21094 7.77744 8.85 7.14149 9.82969 7.14149C10.8094 7.14149 11.4094 7.77744 11.4281 8.60477C11.4281 9.41553 10.8094 10.0711 9.79062 10.0711ZM22.4219 20.6561H19.3844V15.4314C19.3844 14.2153 18.9437 13.3894 17.8453 13.3894C17.0063 13.3894 16.5078 13.9485 16.2875 14.4865C16.2062 14.6779 16.1859 14.9492 16.1859 15.2189V20.6546H13.1469V14.2348C13.1469 13.0579 13.1078 12.0738 13.0672 11.2269H15.7062L15.8453 12.5365H15.9062C16.3062 11.9216 17.2859 11.0144 18.925 11.0144C20.9234 11.0144 22.4219 12.3059 22.4219 15.0818V20.6561Z",
    fill: "#FC654A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linked-in.ab8394d8.svg";
export { ForwardRef as ReactComponent };